import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalHeader, Input } from "reactstrap";

const SearchModal = ({ isOpen, toggle }) => {
const { t } = useTranslation();
  return (
    <Modal modalClassName="modal-search" isOpen={isOpen} toggle={toggle}>
      <ModalHeader>
        <Input placeholder={t('menu.searchPlaceholder')} type="text" />
        <button aria-label="Close" className="close" onClick={toggle}>
          <i className="tim-icons icon-simple-remove" />
        </button>
      </ModalHeader>
    </Modal>
  );
};

export default SearchModal;
